import { customElement, DeesElement, TemplateResult, html } from '@designestate/dees-element';

import * as domtools from '@designestate/dees-domtools';

declare global {
  interface HTMLElementTagNameMap {
    'lele-glowstatus': LeleGlowstatus;
  }
}

@customElement('lele-glowstatus')
export class LeleGlowstatus extends DeesElement {
  public static demo = () => html`<lele-glowstatus></lele-glowstatus>`;

  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        :host {
          display: block;
        }
        .glowwrapper {
          padding: 40px;
          border-radius: 3px;
          background: ${this.goBright ? '#fff' : '#1D1D1D'};
          box-shadow: ${this.goBright ? '0px 0px 5px rgba(0,0,0,0.2)' : ''};
          display: block;
          position: relative;
          min-height: 50px;
          margin-top: 10px;
          overflow: hidden;
        }
        .container {
          width: 250px;
          height: 250px;
          color: ${this.goBright ? '#000000' : '#ffffff'};
          border-radius: 100%;
          margin: auto;
          background: radial-gradient(
            165deg,
            rgba(0, 0, 0, 1) 0%,
            rgb(0, 0, 0) 40%,
            rgb(0, 0, 0) 98%,
            rgb(0, 0, 0) 100%
          );
          position: relative;
          transition: all 0.15s;
        }

        .loader {
        }
        .content {
          cursor: pointer;
          position: absolute;
          width: 100%;
          top: calc(41%);
          text-align: center;
          font-size: 12px;
          font-family: 'Roboto Mono', monospace;
          color: ${this.goBright ? '#444' : '#aaa'};
        }
        img {
          width: 50%;
          filter: opacity(0.8);
          transition: all 1s;
          margin-bottom: 10px;
        }

        .container:hover img {
          filter: opacity(1);
        }

        .loader:before {
          position: absolute;
          content: '';
          width: 100%;
          height: 100%;
          border-radius: 100%;

          border-bottom: 0 solid #4caf5000;
          box-shadow: 0 -10px 20px 20px #4caf5000 inset, 0 -5px 15px 10px #4caf5000 inset,
            0 2px 0px #4caf5000, 0 2px 3px #4caf5000, 0 5px 5px #4caf5000, 0 10px 15px #4caf5000,
            0 10px 20px 20px #4caf5000;
          animation: 3s rotate linear infinite;
          transition: all 0.15s;
        }

        .container.uptodate .loader:before {
          border-bottom: 0 solid #4caf5005;
          box-shadow: 0 -10px 20px 20px #4caf5010 inset, 0 -5px 15px 10px #4caf5010 inset,
            0 2px 0px #4caf5010, 0 2px 3px #4caf5010, 0 5px 5px #4caf5010, 0 10px 15px #4caf5010,
            0 10px 20px 20px #4caf5020;
        }

        .container.needsupdate .loader:before {
          cursor: pointer;
          border-bottom: 0 solid #ff3d0005;
          box-shadow: 0 -10px 20px 20px #ff3d0010 inset, 0 -5px 15px 10px #ff3d0010 inset,
            0 2px 0px #ff3d0010, 0 2px 3px #ff3d0010, 0 5px 5px #ff3d0010, 0 10px 15px #ff3d0010,
            0 10px 20px 20px #ff3d0030;
        }

        .container.needsupdate:hover .loader:before {
          background: #ff3d0010;
        }

        .softwarecomponent {
          padding: 10px;
          margin-right: 10px;
          color: ${this.goBright ? '#000000' : '#ffffff'};
          border: 1px solid ${this.goBright ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'} ;
          line-height: 1.5em;
          text-align: center;
          border-radius: 3px;
          width: 150px;
          float: left;
        }

        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
      </style>
      <div class="glowwrapper">
        <div class="container needsupdate">
          <div class="loader">
            <div class="content">
              <b>service:</b> lossless.com<br />
              <b>version:</b> vx.x.x<br />
              <b>status:</b> <span style="color: #FF3D00;">click to update</span>
            </div>
          </div>
        </div>
      </div>
      <div class="glowwrapper">
        <div class="softwarecomponent">
          <div class="name">frontend</div>
          <div class="version">v3.0.1</div>
        </div>
        <div class="softwarecomponent">
          <div class="name">lele-catalog</div>
          <div class="version">v10.0.14</div>
        </div>
        <div class="softwarecomponent">
          <div class="name">serviceworker</div>
          <div class="version">v5.0.1</div>
        </div>
      </div>
    `;
  }
}
